import { AuthProvider, SignInSmsPage } from '@hub-la/fe-auth'

export const SignInSmsInit = () => {
  return (
    <AuthProvider>
      <SignInSmsPage />
    </AuthProvider>
  )
}
